/**
 * Login Form Validator Class
 */
class LoginFormValidator extends HTMLElement {
  constructor() {
    super();
    this.emailInput = null;
    this.passwordInput = null;
    this.submitButton = null;
    const buttons = this.querySelectorAll('.MOheader button'); 
    buttons[0].classList.add('custom-fb-login-button');   // change Facebook button class on Login page
  }

  connectedCallback() {
    this.emailInput = this.querySelector('#CustomerEmail');
    this.passwordInput = this.querySelector('#CustomerPassword');
    this.submitButton = this.querySelector('form[action*="/account/login"] button[type="submit"]');
    this.loginForm = this.querySelector('form[action*="/account/login"]');
    

    if (this.emailInput && this.passwordInput && this.submitButton) {
      // Initialize button as disabled with reduced opacity
      this.submitButton.disabled = true;
      this.submitButton.classList.add('disabled');
      this.submitButton.style.opacity = '0.65';
      this.submitButton.style.cursor = 'not-allowed';

      // Add event listeners for input fields
      this.emailInput.addEventListener('input', () => this.validateForm());
      this.passwordInput.addEventListener('input', () => this.validateForm());
      
      // Initial validation
      this.validateForm();
    }

    if (this.loginForm) {
      this.loginForm.addEventListener('submit', () => this.handleLoginSubmit());
    }

    this.setupSocialLoginTracking();
  }

  handleLoginSubmit() {
    try {
      sessionStorage.setItem('just_logged_in', 'true');
      sessionStorage.setItem('login_timestamp', new Date().toISOString());
      
    } catch (error) {
      console.error('Error setting login flags:', error);
    }
  }

  setupSocialLoginTracking() {
    const socialLoginButtons = this.querySelectorAll('.MOheader button[onclick*="m("]');
    
    socialLoginButtons.forEach(button => {
      button.addEventListener('click', () => this.handleSocialLoginClick(button));
    });
  }

  handleSocialLoginClick(button) {
    try {
      sessionStorage.setItem('just_logged_in', 'true');
      sessionStorage.setItem('login_timestamp', new Date().toISOString());
      
      const buttonText = button.textContent.trim();
      let provider = 'unknown';
      
      if (buttonText.includes('Google') || button.getAttribute('onclick')?.includes('google')) {
        provider = 'google';
      } else if (buttonText.includes('Facebook') || button.getAttribute('onclick')?.includes('facebook')) {
        provider = 'facebook';
      }
      
      sessionStorage.setItem('login_provider', provider);
    } catch (error) {
      console.error('Error setting social login flags:', error);
    }
  }

  validateForm() {
    const emailValue = this.emailInput.value.trim();
    const passwordValue = this.passwordInput.value.trim();
    
    if (emailValue && passwordValue) {
      // Enable the button if both fields are filled
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('disabled');
      this.submitButton.style.opacity = '1';
      this.submitButton.style.cursor = 'pointer';
      this.submitButton.style.backgroundColor = '#20544b';
      this.submitButton.style.color = '#ffffff';
    } else {
      // Disable the button if either field is empty
      this.submitButton.disabled = true;
      this.submitButton.classList.add('disabled');
      this.submitButton.style.opacity = '.65';
      this.submitButton.style.cursor = 'not-allowed';
    }
  }
}

if (!customElements.get('supergut-login-form')) {
  customElements.define('supergut-login-form', LoginFormValidator);
}
(function() {
  var passwordInput = document.getElementById('CustomerPassword');
  var toggleBtn = document.getElementById('toggle-password-visibility');
  var eyeIcon = document.getElementById('eye-icon');
  if (toggleBtn && passwordInput) {
    toggleBtn.addEventListener('click', function() {
      var isPassword = passwordInput.type === 'password';
      passwordInput.type = isPassword ? 'text' : 'password';
      toggleBtn.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
      toggleBtn && toggleBtn.classList.toggle('visible');
    });
  }
})();